/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/exceptionResponseDTO';
import { PageRendicontazioneReportView } from '../model/pageRendicontazioneReportView';
import { PageRicaricaReportView } from '../model/pageRicaricaReportView';
import { RicaricaStatisticheDTO } from '../model/ricaricaStatisticheDTO';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class RicaricheService {

    protected basePath = 'https://demo-api.mensapp.it/gestione-mense';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Permette di ricevere il report paginato delle rendicontazioni.
     * Restituisce una lista paginata di rendicontazioni con informazioni dettagliate su studente, genitore e scuola. È possibile filtrare per numero mese. ATTENZIONE: Funziona solo se il comune ha tipoPagamento &#x3D; PAGO_PA_RENDICONTAZIONE.
     * @param slugComune Slug del comune
     * @param page Il numero della pagina da recuperare. Basato su zero. Il valore predefinito è 0.
     * @param size Il numero di elementi da recuperare. Il valore predefinito è 20.
     * @param sort I criteri di ordinamento nel formato: proprietà(,asc|desc). L&#x27;ordinamento predefinito è per meseRendicontazione asc. Sono supportati più criteri di ordinamento.
     * @param numeroMese Numero del mese (1-12)
     * @param nominativo Nome e/o cognome dello studente o genitore (ricerca su entrambi i campi)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRendicontazioniReport(slugComune: string, page?: number, size?: number, sort?: string, numeroMese?: number, nominativo?: string, observe?: 'body', reportProgress?: boolean): Observable<PageRendicontazioneReportView>;
    public getRendicontazioniReport(slugComune: string, page?: number, size?: number, sort?: string, numeroMese?: number, nominativo?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageRendicontazioneReportView>>;
    public getRendicontazioniReport(slugComune: string, page?: number, size?: number, sort?: string, numeroMese?: number, nominativo?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageRendicontazioneReportView>>;
    public getRendicontazioniReport(slugComune: string, page?: number, size?: number, sort?: string, numeroMese?: number, nominativo?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (slugComune === null || slugComune === undefined) {
            throw new Error('Required parameter slugComune was null or undefined when calling getRendicontazioniReport.');
        }






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (sort !== undefined && sort !== null) {
            queryParameters = queryParameters.set('sort', <any>sort);
        }
        if (slugComune !== undefined && slugComune !== null) {
            queryParameters = queryParameters.set('slugComune', <any>slugComune);
        }
        if (numeroMese !== undefined && numeroMese !== null) {
            queryParameters = queryParameters.set('numeroMese', <any>numeroMese);
        }
        if (nominativo !== undefined && nominativo !== null) {
            queryParameters = queryParameters.set('nominativo', <any>nominativo);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PageRendicontazioneReportView>('get',`${this.basePath}/api/v1/ricarica/rendicontazioni/report`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di ricevere il report paginato delle ricariche con possibilità di filtraggio per data e stato.
     * Restituisce una lista paginata di ricariche con informazioni dettagliate su studente, genitore e scuola. È possibile filtrare per intervallo di date (data pagamento) e per stato interno della ricarica.
     * @param slugComune Slug del comune
     * @param page Il numero della pagina da recuperare. Basato su zero. Il valore predefinito è 0.
     * @param size Il numero di elementi da recuperare. Il valore predefinito è 20.
     * @param sort I criteri di ordinamento nel formato: proprietà(,asc|desc). L&#x27;ordinamento predefinito è per dataPagamento desc. Sono supportati più criteri di ordinamento.
     * @param dataDa Data inizio filtro (formato: yyyy-MM-dd)
     * @param dataA Data fine filtro (formato: yyyy-MM-dd)
     * @param statoInterno Stato interno della ricarica (GENERAZIONE_IN_CORSO, IN_ATTESA_PAGAMENTO, PAGATA, ERRORE, CANCELLATA)
     * @param nominativo Nome e/o cognome dello studente o genitore (ricerca su entrambi i campi)
     * @param filtraPerDataPagamento Se true filtra per dataPagamento, se false filtra per data. Se non specificato, la scelta dipende dal tipo di pagamento del comune (MANUALE -&gt; dataPagamento, PAGO_PA_* -&gt; data)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRicaricheReport(slugComune: string, page?: number, size?: number, sort?: string, dataDa?: string, dataA?: string, statoInterno?: string, nominativo?: string, filtraPerDataPagamento?: boolean, observe?: 'body', reportProgress?: boolean): Observable<PageRicaricaReportView>;
    public getRicaricheReport(slugComune: string, page?: number, size?: number, sort?: string, dataDa?: string, dataA?: string, statoInterno?: string, nominativo?: string, filtraPerDataPagamento?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PageRicaricaReportView>>;
    public getRicaricheReport(slugComune: string, page?: number, size?: number, sort?: string, dataDa?: string, dataA?: string, statoInterno?: string, nominativo?: string, filtraPerDataPagamento?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PageRicaricaReportView>>;
    public getRicaricheReport(slugComune: string, page?: number, size?: number, sort?: string, dataDa?: string, dataA?: string, statoInterno?: string, nominativo?: string, filtraPerDataPagamento?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (slugComune === null || slugComune === undefined) {
            throw new Error('Required parameter slugComune was null or undefined when calling getRicaricheReport.');
        }









        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (sort !== undefined && sort !== null) {
            queryParameters = queryParameters.set('sort', <any>sort);
        }
        if (slugComune !== undefined && slugComune !== null) {
            queryParameters = queryParameters.set('slugComune', <any>slugComune);
        }
        if (dataDa !== undefined && dataDa !== null) {
            queryParameters = queryParameters.set('dataDa', <any>dataDa);
        }
        if (dataA !== undefined && dataA !== null) {
            queryParameters = queryParameters.set('dataA', <any>dataA);
        }
        if (statoInterno !== undefined && statoInterno !== null) {
            queryParameters = queryParameters.set('statoInterno', <any>statoInterno);
        }
        if (nominativo !== undefined && nominativo !== null) {
            queryParameters = queryParameters.set('nominativo', <any>nominativo);
        }
        if (filtraPerDataPagamento !== undefined && filtraPerDataPagamento !== null) {
            queryParameters = queryParameters.set('filtraPerDataPagamento', <any>filtraPerDataPagamento);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PageRicaricaReportView>('get',`${this.basePath}/api/v1/ricarica/report`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Permette di ricevere le statistiche aggregate sulle ricariche.
     * Restituisce statistiche numeriche sulle ricariche: totale ricariche (IN_ATTESA_PAGAMENTO + PAGATA), totale importo pagato (solo PAGATA), totale importo in attesa di pagamento (solo IN_ATTESA_PAGAMENTO).
     * @param slugComune Slug del comune
     * @param filtraPerDataPagamento Se true filtra per dataPagamento, se false filtra per data. Se non specificato, la scelta dipende dal tipo di pagamento del comune (MANUALE -&gt; dataPagamento, PAGO_PA_* -&gt; data)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRicaricheStatistiche(slugComune: string, filtraPerDataPagamento?: boolean, observe?: 'body', reportProgress?: boolean): Observable<RicaricaStatisticheDTO>;
    public getRicaricheStatistiche(slugComune: string, filtraPerDataPagamento?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<RicaricaStatisticheDTO>>;
    public getRicaricheStatistiche(slugComune: string, filtraPerDataPagamento?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<RicaricaStatisticheDTO>>;
    public getRicaricheStatistiche(slugComune: string, filtraPerDataPagamento?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (slugComune === null || slugComune === undefined) {
            throw new Error('Required parameter slugComune was null or undefined when calling getRicaricheStatistiche.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (slugComune !== undefined && slugComune !== null) {
            queryParameters = queryParameters.set('slugComune', <any>slugComune);
        }
        if (filtraPerDataPagamento !== undefined && filtraPerDataPagamento !== null) {
            queryParameters = queryParameters.set('filtraPerDataPagamento', <any>filtraPerDataPagamento);
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<RicaricaStatisticheDTO>('get',`${this.basePath}/api/v1/ricarica/statistiche`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
